import { cn } from "@/shared/utils/cn";
import Textfield from "../Input/Textfield";
import { useTranslation } from "react-i18next";

const SplitPaymentLedgerEmail = ({ ledger, isOnline, updateLedger }) => {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "transition-all ease-in duration-200",
        isOnline ? "h-20 opacity-100 visible" : "h-0 opacity-0 invisible"
      )}
    >
      <Textfield
        type="email"
        value={ledger.transaction_email || ""}
        onChange={(e) =>
          updateLedger(ledger.item_id, {
            transaction_email: e.target.value,
          })
        }
        error={ledger.transaction_email ? undefined : t("fieldRequired")}
        hideErrorMessage
        placeholder="moeders@email.com"
        width={{ _: "100%", md: "20rem" }}
      />
    </div>
  );
};

export default SplitPaymentLedgerEmail;
